import { DynamicScrollerItem as UnpatchedDynamicScrollerItem } from 'vue-virtual-scroller';

export { DynamicScroller, IdState, RecycleScroller } from 'vue-virtual-scroller';

/*
 * DynamicScrollerItem renders its default slot using the Vue 3 syntax
 * (`this.$slots.default()`). Since we've globally set @vue/compat to operate
 * in Vue 2 mode, it's restoring the structure of `$slots` to what it was in
 * Vue 2 (so `this.$slots.default` is an array of vnodes instead of a
 * function).
 *
 * To work around this, we are re-exporting DynamicScrollerItem with the
 * RENDER_FUNCTION compat flag disabled.
 */
export const DynamicScrollerItem = {
    ...UnpatchedDynamicScrollerItem,
    compatConfig: {
        RENDER_FUNCTION: false,
    },
};
